import { request } from "@/lib/auth";

export interface ValueChainStage {
  id: string;
  sector: string;
  name: string;
  description: string | null;
  sortOrder: number;
}

export interface AssetType {
  id: string;
  sector: string;
  name: string;
  valueChainStageId: string | null;
}

export interface Asset {
  id: string;
  workspaceId: string;
  name: string;
  assetTypeId: string | null;
  customAssetTypeName: string | null;
  valueChainStageId: string | null;
  address: string | null;
  latitude: string | null;
  longitude: string | null;
  city: string;
  country: string;
  businessImportance: 1 | 2 | 3 | 4;
  createdAt: string | null;
  updatedAt: string | null;
}

export function listValueChainStages() {
  return request<{ stages: ValueChainStage[] }>("/api/value-chain-stages");
}

export function listAssetTypes() {
  return request<{ assetTypes: AssetType[] }>("/api/asset-types");
}

export function listAssets() {
  return request<{ assets: Asset[] }>("/api/assets");
}

export interface AssetInput {
  name: string;
  assetTypeId: string | null;
  customAssetTypeName: string | null;
  valueChainStageId: string | null;
  address: string | null;
  latitude: number | null;
  longitude: number | null;
  city: string;
  country: string;
  businessImportance: 1 | 2 | 3 | 4;
}

export function createAsset(input: AssetInput) {
  return request<{ asset: Asset }>("/api/assets", { method: "POST", body: JSON.stringify(input) });
}

export function updateAsset(id: string, input: Partial<AssetInput>) {
  return request<{ asset: Asset }>(`/api/assets/${id}`, { method: "PATCH", body: JSON.stringify(input) });
}

export function deleteAsset(id: string) {
  return request<void>(`/api/assets/${id}`, { method: "DELETE" });
}

export interface ValueChainImportanceRating {
  valueChainStageId: string;
  importance: 0 | 1 | 2 | 3 | 4;
}

export function getWorkspaceValueChainImportance() {
  return request<{ ratings: ValueChainImportanceRating[] }>("/api/workspace-value-chain-importance");
}

export function putWorkspaceValueChainImportance(ratings: ValueChainImportanceRating[]) {
  return request<{ ratings: ValueChainImportanceRating[] }>("/api/workspace-value-chain-importance", {
    method: "PUT",
    body: JSON.stringify({ ratings }),
  });
}

export interface BulkAssetEntry {
  row: number;
  asset: AssetInput;
}

export interface BulkAssetRowError {
  row: number;
  message: string;
}

export function bulkCreateAssets(entries: BulkAssetEntry[]) {
  return request<{ assets: Asset[] }>("/api/assets/bulk", {
    method: "POST",
    body: JSON.stringify({ assets: entries }),
  });
}
